import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useUserFilter = (userIsJustAnInstaller: boolean) => {
  const location = useLocation();

  const [selectedFilter, setUserFilter] = useState<string>(
    location.state?.filter || (userIsJustAnInstaller ? "incomplete" : "all")
  );

  useEffect(() => {
    if (userIsJustAnInstaller) {
      setUserFilter("incomplete");
    }
  }, [userIsJustAnInstaller]);

  return { selectedFilter, setUserFilter };
};
